<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
    class="flex flex-initial text-gray-900/80 mx-auto w-6 shrink-0 opacity-90 rotate-90 lg:rotate-0"
  >
    <path
      fill-rule="evenodd"
      d="M3 10a.75.75 0 0 1 .75-.75h10.638L10.23 5.29a.75.75 0 1 1 1.04-1.08l5.5 5.25a.75.75 0 0 1 0 1.08l-5.5 5.25a.75.75 0 1 1-1.04-1.08l4.158-3.96H3.75A.75.75 0 0 1 3 10Z"
      clip-rule="evenodd"
    ></path>
  </svg>
</template>

<script>
export default {
  name: 'LandingHowItWorksArrow'
}
</script>
